// import './style.css';
// import * as echarts from 'echarts';
import './flowbite2.5.2.min.js';
import './sidebar';
import './charts';
import './dark-mode';

// Have the courage to follow your heart and intuition.
